import { useEffect } from "react";

export default function Unauthorized() {
  useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");
    if (sessionId) {
      localStorage.removeItem("sessionId");
    }
  }, []);

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <div className="text-center">
        <p className="text-2xl mt-2 text-black dark:text-lz-concrete">
          It looks like you are trying to log in to Lezioni! Your session has
          expired, so please visit your Membership Portal at{" "}
          <a
            href="https://amorc.customerhub.net/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
          >
            https://amorc.customerhub.net/
          </a>
          .
        </p>
        <p className="text-xl mt-2 text-black dark:text-lz-concrete">
          Log in and then click the &quot;Lezioni Login&quot; button in the right
          sidebar.
        </p>
      </div>
    </div>
  );
}
